<p-tabView styleClass="tabview-custom">
<p-tabPanel header="Header I">
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-2">
      <span class="font-bold white-space-nowrap m-0">
       Account settings
      </span>
    </div>
  </ng-template>
    <div class="cards">
      <div class="grid gap-4 flex-column py-4">
           <form [formGroup]="passwordForm" > 
          <h6 class="m-0 mb-3">{{'Change Password' | sentenceCase}}</h6>
          <div class="flex flex-column gap-3 mb-3">
            <p-floatLabel>
                    <p-password  formControlName="currentPassword" [feedback]="false" [toggleMask]="true" styleClass="md:w-30rem w-full" />
              <label for="password">{{'Enter Current Password' | sentenceCase}}<span class="required">*</span></label>
                 
            </p-floatLabel>
            <p-floatLabel>
                    <p-password formControlName="newPassword" [toggleMask]="true" styleClass="md:w-30rem w-full" />
              <label for="password">{{'Enter New Password' | sentenceCase}}<span class="required">*</span></label>
                    
            </p-floatLabel>
            <p-floatLabel>
                    <p-password formControlName="confirmPassword" [feedback]="false" [toggleMask]="true" styleClass="md:w-30rem w-full" />
              <label for="password">{{'Confirm Password' | sentenceCase}}<span class="required">*</span></label>
                   
            </p-floatLabel>
          </div>
          <div>
                <p-button label="update password" (click)="onPassSubmit()" rounded="true" size="large"  [disabled]="passwordForm.invalid" outlined="true"></p-button>
          </div>
        </form>

        <h6 class="m-0">{{'Notification Settings' | sentenceCase}}</h6>
        <div class="flex flex-column gap-3">
               
          <form [formGroup]="notificationSwitches" class=" ">
            <div class="flex gap-3 px-2 mb-3">
              @if (notificationPref) {
                <p-inputSwitch formControlName="email"  (onChange)="updatePreference('email')" [disabled]="getBool(notificationPref!.unAvailableStatus)"/>
                <label for="emailId" class="line-height-2">Email</label>
              }
            </div>
            @if(reviewer){  
              <div class="flex gap-3 px-2 mb-3 align-items-center">
                  <p-inputSwitch formControlName="notification" (onChange)="updatePreference('notification')" inputId="notification" />
                  <label for="notification" class="line-height-2">{{'Mobile app push notifications' | sentenceCase}}</label>
                  @if (!reviewer.arn) {
                    <span class="text-500 text-sm ml-1">— Get the app to enable push notifications</span>
                    <div class="flex gap-2 ml-2">
                      <p-button
                        icon="pi pi-apple"
                        label="App Store"
                        size="small"
                        outlined="true"
                        severity="secondary"
                        (onClick)="showAppDownloadPopup('ios')"
                      ></p-button>
                      <p-button
                        icon="pi pi-android"
                        label="Google Play"
                        size="small"
                        outlined="true"
                        severity="secondary"
                        (onClick)="showAppDownloadPopup('android')"
                      ></p-button>
                    </div>
                  }
              </div>

              <!-- App Download Modal -->
              <p-dialog
                header="Download the Mobile App"
                [(visible)]="showAppDownloadModal"
                [modal]="true"
                [closable]="true"
                [dismissableMask]="true"
                styleClass="app-download-dialog"
                [style]="{width: '420px'}"
              >
                <div class="flex flex-column align-items-center gap-4 py-2">
                  <p class="text-center m-0 text-700">Scan the QR code with your phone camera or use the links below to download the Staftr mobile app.</p>
                  <qrcode
                    [qrdata]="appUrl"
                    [width]="180"
                    [allowEmptyString]="true"
                    [errorCorrectionLevel]="'M'"
                    cssClass="qr-code-block"
                  ></qrcode>
                  <div class="flex gap-3">
                    @if(appUrl === appStoreUrl){
                      <a [href]="appStoreUrl" target="_blank" rel="noopener noreferrer">
                        <p-button icon="pi pi-apple" label="App Store" outlined="true"></p-button>
                      </a>
                    }
                    @else if(appUrl === playStoreUrl){
                      <a [href]="playStoreUrl" target="_blank" rel="noopener noreferrer">
                        <p-button icon="pi pi-android" label="Google Play" outlined="true"></p-button>
                      </a>
                    }
                  </div>
                  <p class="text-sm text-500 text-center m-0">Once you've logged in on the mobile app, push notifications will be automatically enabled here.</p>
                </div>
              </p-dialog>
            }

            <div class="flex gap-3 px-2">
              <p-inputSwitch formControlName="sms" (onChange)="updatePreference('sms')" inputId="textMessages" />
              
              <div class="p-col-12">
                <div class="mp-form-field">
                  <label>{{'Text message (SMS)' | sentenceCase}}</label>
                  @if(notificationSwitches.value.sms){
                  <div class="flex flex-column md:flex-row gap-3">
                    <p-floatLabel class="mr-8"><span class="mp-form-text p-mr-2 p-col">{{phone.partOne}}-{{phone.partTwo}}-{{phone.partThree}}</span></p-floatLabel>
                    @if(!this.reviewer.profile.contact.isPhoneVerified){
                    <p-floatLabel><button pButton type="button" label="verify" class="p-button-primary" (click)="sendVerificationPhoneSms()"></button></p-floatLabel>
                    }
                  </div>
                  }
                </div>
              </div>
                    
            </div>
          </form>

          <!-- Edit Phone Form -->
          <form [formGroup]="editPhoneForm" *ngIf="showEditPhoneForm" class="w-100">
            <div>
              <label>Phone No</label>
              <div class="flex flex-column md:flex-row gap-3">
                <p-floatLabel>
                          <p-inputMask styleClass="md:w-20rem w-full" mask="999" formControlName="partOne" placeholder="123"></p-inputMask>
                </p-floatLabel>
                <p-floatLabel>
                          <p-inputMask styleClass="md:w-20rem w-full" mask="999" formControlName="partTwo" placeholder="456"></p-inputMask>
                </p-floatLabel>
                <p-floatLabel>
                          <p-inputMask styleClass="md:w-20rem w-full" mask="9999" formControlName="partThree" placeholder="7890"></p-inputMask>
                </p-floatLabel>
              </div>
            </div>
            <div class="p-grid p-justify-end p-align-center mt-3">
              <button pButton type="button" label="cancel" class="p-button-secondary mr-2" (click)="editPhoneNo()"></button>
              <button pButton type="button" label="update" class="p-button-primary" [disabled]="getBool(!editPhoneForm.valid)" (click)="updatePhone()"></button>
            </div>
            <br />
          </form>

          <!-- Verification Phone Form -->
          <form [formGroup]="verificationPhoneForm" *ngIf="_isShowVerificationPhoneForm" class="mb-3 w-100">
            <div class="p-grid p-nogutter">
              <div class="p-col">
                <div class="mp-form-field w-30rem">
                  <label>{{'Verification Code' | sentenceCase}}</label>
                          <p-inputMask mask="9999" formControlName="verificationCode" placeholder="1234"></p-inputMask>
                </div>
              </div>
            </div>
            <div class="p-grid p-justify-end p-align-center mt-3">
              <button pButton type="button" label="cancel" class="p-button-secondary mr-2" (click)="showVerificationPhoneForm()"></button>
              <button pButton type="button" label="verify" class="p-button-primary" [disabled]="getBool(!verificationPhoneForm.valid)" (click)="verifyPhone()"></button>
            </div>
            <br />
          </form>
          <form [formGroup] = "unAvailableForm">
            <div class="flex gap-3 px-2 mb-3 align-items-center">
              <p-inputSwitch inputId="unavailabilityStatus" formControlName="unAvailableStatus" (onChange)="updatePreference('unAvailableStatus')" />
              <label for="unavailabilityStatus" class="line-height-2">{{'Unavailability Status' | sentenceCase}}</label>
              <div class="flex align-items-center">
                <span 
                [pTooltip]="getAvailablityTooltipContent()" 
                tooltipPosition="top" 
                icon="true"
                class="{{helperService.getEnvironmentName()}}-icon icon-info-outlined cursor-pointer text-primary-600"></span>
              </div>
            </div>
            @if(unAvailableForm.value.unAvailableStatus){
              <div class="flex flex-column md:flex-row gap-3 mb-3">
                <p-floatLabel>
                  <p-calendar inputId="startDate" formControlName="startDate" [minDate]="minStartDate" [maxDate]="maxStartDate"/>
                  <label for="startDate">{{'Start Date' | sentenceCase}}</label>
                </p-floatLabel>
                <p-floatLabel>
                  <p-calendar inputId="endDate" formControlName="endDate" [minDate]="minEndDate" [maxDate]="maxEndDate"/>
                  <label for="endDate">{{'End Date' | sentenceCase}}</label>
                </p-floatLabel>
                    
              </div>

              <div class="flex flex-column md:flex-row gap-3">
                <p-button  label="submit" rounded="true" size="large" outlined="true" (click)="updatePreference('unAvailableStatus')"></p-button>
              </div>
            }
          </form>

          <div class="flex flex-column md:flex-row gap-3 md:gap-6 md:align-items-center">
            <span class="font-bold">Remove my {{title}} account</span>
            <p-button
              label="remove account"
              (click)="requestAccountDeletion()"
              rounded="true"
              size="large"
              severity="danger"
            ></p-button>
          </div>
        </div>
      </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Header II">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <span class="font-bold white-space-nowrap m-0">
            Personal information
          </span>
        </div>
      </ng-template>
      <form [formGroup]="profileForm">
        <div class="grid xl:w-9 w-full pt-4">
          <div class="lg:col-6 col-12">
            <p-floatLabel>
              <input
                formControlName="firstName"
                type="text"
                pInputText
                id="firstname"
              />
              <label for="firstname">{{'First Name' | sentenceCase}}<span class="required">*</span></label>
            </p-floatLabel>
          </div>
          <div class="lg:col-6 col-12">
            <p-floatLabel>
              <input
                formControlName="lastName"
                type="text"
                pInputText
                id="lastname"
              />
              <label for="lastname">{{'Last Name' | sentenceCase}}<span class="required">*</span></label>
            </p-floatLabel>
          </div>
          <div class="col-12">
              <p-floatLabel>
                <input
                  formControlName="preferredFirstName"
                  type="preferredFirstName"
                  pInputText
                  inputId="PreferredFirstName"
                />
                <label for="PreferredFirstName">Preferred First Name</label>
              </p-floatLabel>
          </div>
          <div class="col-12">
            <div class="flex gap-3">
              <p-floatLabel class="w-full">
                <input
                  formControlName="email"
                  type="email"
                  pInputText
                  inputId="Email"
                />
                <label for="Email">Email</label>
              </p-floatLabel>
              <p-button
                    label="{{emailBtnText}}"
                    rounded="true"
                    size="large"
                    styleClass="white-space-nowrap"
                    (onClick)="changeEmail()"
              ></p-button>
            </div>
          </div>
        </div>

        <div formGroupName="profile" class="flex flex-column justify-content-between h-page-half">
          @if (allowEditFields.dob) {
            <div class="pl-0 pr-0 col-5">
                <p-floatLabel>
                    <p-calendar [maxDate]="maxDate" formControlName="dob" inputId="dob" [iconDisplay]="'input'" [showIcon]="true" />
                    <label for="dob">Date of birth<span class="required">*</span></label>
                </p-floatLabel>
            </div>
          }
          @if (allowEditFields.ssn) {
            <div class="pl-0 pr-0 col-5">
                <p-floatLabel>
                    <input (input)="formatSSN($event)" maxlength="11" placeholder="000-00-0000" pattern="[0-9]{3}-[0-9]{2}-[0-9]{4}" formControlName="ssn" type="text" pInputText id="socialSecurity" />
                    <label for="ssn">{{'Social Security' | sentenceCase}}<span class="required">*</span></label>
                </p-floatLabel>
            </div>
          }
          <div formGroupName="contact" class="grid xl:w-9 w-full pt-2">
            <div class="lg:col-6 col-12">
              <div class="flex gap-3">
                <p-floatLabel class="w-full">
                  <input formControlName="home" type="text" (input)="formatContact($event)"
                    pInputText maxlength="12" placeholder="000-000-0000" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                  />
                  <label for="phone">Phone</label>
                </p-floatLabel>
                @if(!isPhoneVerified){
                  <p-button
                  label="get code"
                  rounded="true"
                  size="large"
                  styleClass="white-space-nowrap"
                  [disabled]="isPhoneVerified"
                  (onClick)="sendVerificationCode()"
                  ></p-button>
                }
                @else {
                  <p-button
                  label="change phone number"
                  rounded="true"
                  size="large"
                  styleClass="white-space-nowrap"
                  (onClick)="enablePhoneField()"
                  ></p-button>
                }
              </div>
            </div>
            @if(!isPhoneVerified){
              <div class="lg:col-6 col-12">
                <div class="flex gap-3">
                  <p-floatLabel class="w-full">
                    <input
                      type="text"
                      pInputText
                      id="verificationCode"
                      #verificationCodeInput
                    />
                    <label for="verificationCode">{{'Verification Code' | sentenceCase}}</label>
                  </p-floatLabel>
                  <p-button
                    label="verify code"
                    rounded="true"
                    size="large"
                    styleClass="white-space-nowrap"
                    (onClick)="verify(verificationCodeInput.value)"
                  ></p-button>
                </div>
              </div>
            }@else {
              <div class="lg:col-6 col-12"></div>
            }
            @if(!isPWCEnabled){
              <div class="col-12">
                <p-floatLabel>
                  <input
                    formControlName="street"
                    type="text"
                    pInputText
                    id="address"
                  />
                  <label for="address">Address<span class="required">*</span></label>
                </p-floatLabel>
              </div>
            }
            <div class="lg:col-6 col-12">
              <p-floatLabel>
                <input
                  formControlName="city"
                  inputId="city"
                  placeholder="City"
                  pInputText
                />
                <label for="city">City<span class="required">*</span></label>
              </p-floatLabel>
            </div>
            <div class="lg:col-3 col-12">
              <p-floatLabel>
                <p-dropdown
                  [options]="stateDropDown"
                  formControlName="state"
                  inputId="states"
                  appendTo="body"
                  optionLabel="name"
                ></p-dropdown>
                <label for="states">State<span class="required">*</span></label>
              </p-floatLabel>
            </div>
            <div class="lg:col-3 col-12">
              <p-floatLabel>
                <input
                  formControlName="zipCode"
                  pInputText
                  id="zip"
                />
                <label for="zipCode">Zip Code<span class="required">*</span></label>
              </p-floatLabel>
            </div>
            
          </div>
          @if(currentTenant?.firm.isCitizenshipStatusRequired){
            <div class="pl-0 pr-0 col-4">
              <p-floatLabel>
                <p-dropdown
                  [options]="citizenshipType"
                  formControlName="immigrationStatus"
                  inputId="citizenshipType"
                  appendTo="body"
                  optionLabel="name"
                ></p-dropdown>
                <label for="citizenshipType">{{'Citizenship Type' | sentenceCase}}<span class="required">*</span></label>
              </p-floatLabel>
            </div>
          }
          <div class="flex gap-3 mt-3">
            <p-button
              label="back"
              rounded="true"
              outlined="true"
              size="large"
              styleClass="white-space-nowrap"
              (onClick)="onDiscard()"
            ></p-button>
            <p-button
              label="save"
              rounded="true"
              size="large"
              [disabled]="!profileForm.valid"
              styleClass="white-space-nowrap freshgreen-background"
              (onClick)="onSubmit()"
            ></p-button>
          </div>
        </div>
      </form>
    </p-tabPanel>
  </p-tabView>
<!-- </div> -->

